import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="unit-count">
          <span>单位总数: 45</span>
        </div>
        <div className="warnings">
          <span>预警信息: 无</span>
        </div>
        <div className="data-source">
          <span>数据来源: 福建省烟草专卖局</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;